import { COMPANY } from '../../../content/staticAssets';

export default function MissionVision() {
  return (
    <div className="section">
      <div className="container-x min-w-0">
        <div className="max-w-3xl">
          <p className="eyebrow">What we believe</p>
          <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            Enterprise AI needs shared business meaning, not just more data.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">
            Most organizations already have dashboards, data warehouses, reports, and AI tools. The challenge is that they do not
            share the same business context. We help organizations define once and consume everywhere through governed semantic foundations.
          </p>
        </div>

        <section className="mt-16 grid grid-cols-1 items-start lg:grid-cols-2 lg:gap-x-12">
          <div className="min-w-0 lg:pr-4">
            <h3 className="text-2xl font-semibold tracking-tight text-ink-900">Snowflake Enterprise AI focus</h3>
            <p className="mt-5 text-base leading-7 text-ink-600">
              We focus on Snowflake-native semantic architecture, governed data layers, reusable metrics,
              secure reporting views, and AI-ready context that supports Cortex, Power BI, Tableau, QuickSight,
              Streamlit, and embedded analytics applications.
            </p>
            <p className="mt-4 text-base leading-7 text-ink-600">
              From dashboards to decision intelligence, and from data pipelines to domain memory,
              we build systems that your teams run and govern in your own enterprise environment.
            </p>
          </div>

          <div className="mt-10 min-w-0 lg:mt-0">
            <div className="grid grid-cols-2 gap-4">
              <div className="aspect-square overflow-hidden rounded-xl border border-ink-200 bg-[#00123F] shadow-sm">
                <img
                  alt="Governed analytics workspace on an enterprise laptop"
                  src={COMPANY.missionWorkspace}
                  className="block size-full object-cover"
                />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl border border-ink-200 bg-surface-subtle shadow-sm">
                <img
                  alt="Enterprise dashboard used to consume shared semantic metrics"
                  src={COMPANY.missionProduct}
                  className="block size-full object-cover object-top"
                />
              </div>
              <div
                className="col-span-2 overflow-hidden rounded-xl border border-brand-700/20 px-6 py-5"
                style={{
                  background:
                    'linear-gradient(135deg, rgba(0,18,63,0.96) 0%, rgba(0,180,254,0.88) 72%, rgba(25,227,242,0.78) 100%)',
                }}
              >
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#19E3F2]">
                  Define once
                </p>
                <p className="mt-2 font-display text-lg font-semibold text-white">
                  Consume everywhere: BI, apps, and agents from the same governed meaning.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
